import React, { useEffect, useState, useContext } from "react";
import { Card } from "@mui/material";
import { CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import SearchPatientAnalysis from "../../../Classes/Models/Requests/Accounting/SearchPatientAnalysis";
import { LanguageContext } from "App";
const PatientAnalyticsSearch = ({ setSearchReq }) => {
  let req = new SearchPatientAnalysis();

  const [Id, setId] = useState();
  const [UserName, setUserName] = useState();
  const [TotalSessions, setTotalSessions] = useState();
  const [Admitted, setAdmitted] = useState();
  const [Appointments, setAppointments] = useState();
  const [Exceptions, setExceptions] = useState();
  const [sortBy, setSortBy] = useState();
  const [sortOrder, setSortOrder] = useState();
  const { translations } = useContext(LanguageContext);

  const onSearchClick = async () => {
    req.id = Id;
    req.name = UserName;
    req.sessionsCount = TotalSessions;
    req.admittedSessionsCount = Admitted;
    req.appointmentSessionsCount = Appointments;
    req.exceptionCount = Exceptions;
    req.sortBy = sortBy;
    req.sortOrder = sortOrder;

    setSearchReq(req);
  };

  useEffect(() => {
    onSearchClick();
  }, [sortBy, sortOrder]);

  return (
    <Card sx={{ padding: "1em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.SearchPatientAnalytics}
        </MDTypography>
        <div>
          <MDButton
            type="button"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="text"
            onClick={() => onSearchClick()}
          >
            {translations.SearchPatientAnalyticsSearch}
          </MDButton>
        </div>
      </MDBox>
      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <div className="container-fluid mt-4">
          <div className="row">
            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsUserId}
                onChange={(e) => setId(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsUserName}
                onChange={(e) => setUserName(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsTotalSessions}
                onChange={(e) => setTotalSessions(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsAppointments}
                onChange={(e) => setAppointments(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsAdmitted}
                onChange={(e) => setAdmitted(e.target.value)}
                type="number"
                fullWidth
              />
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                sx={{ width: "100%" }}
                label={translations.SearchPatientAnalyticsExceptions}
                onChange={(e) => setExceptions(e.target.value)}
                type="number"
                fullWidth
              />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PatientAnalyticsSearch;
